<div class="component-wrapper">
    <div class="component-content">
        <header>
            <h1 class="title" [innerHTMLBypassXSS]="title"></h1>
            <p class="subtitle" [innerHTMLBypassXSS]="subtitle"></p>
        </header>
        <div class="list">
            <ng-container *ngIf="showList">
                <div *ngFor="let item of anfragen">
                    <anfrage-card *ngIf="item" [anfrage]="item" (anfrageDelete)="onAnfrageDelete($event)"></anfrage-card>
                </div>
            </ng-container>
        </div>
        <span *ngIf="!showList" translate>request.none_available</span>
    </div>
</div>